export default {
  USER: 'user',
  SERVICE: 'service',
  ADMIN: 'admin',
  CREATOR: 'creator',
  SIGNER: 'signer',
  APPROVER: 'approver'
}
